import { uniqBy } from 'lodash/fp';
import { ID } from '../constants';
import { Identifiable } from '../interfaces';

export const uniqById = <T extends Identifiable<unknown>>(array: T[]): T[] => uniqBy(ID, array);
